import React, { forwardRef, memo } from 'react'

const DatabaseIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width={36.4}
      height={36.4}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      fill="none"
      stroke="#78BE20"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M19.5 24.375c8.975 0 16.25-3.274 16.25-7.313s-7.275-7.313-16.25-7.313S3.25 13.024 3.25 17.063s7.275 7.312 16.25 7.312Z" />
      <path d="M3.25 17.063v8.125c0 4.038 7.276 7.312 16.25 7.312s16.25-3.274 16.25-7.312v-8.125" />
      <path d="M13 23.766v8.125" />
      <path d="M35.75 19.647c7.418.679 13 3.628 13 7.166 0 4.038-7.276 7.313-16.25 7.313-3.981 0-7.629-.644-10.454-1.714" />
      <path d="M16.25 32.354v2.584c0 4.038 7.276 7.312 16.25 7.312s16.25-3.274 16.25-7.312v-8.125" />
      <path d="M39 33.516v8.125M26 23.766v17.875" />
    </svg>
  )
)

DatabaseIcon.displayName = 'DatabaseIcon'
export default memo(DatabaseIcon)
